<template>
  <div class="free-to-play-wrapper">
    <div class="game-list-box" v-if="gameList.length">
      <div class="title-box">
        <img src="@/assets/images/games/bulletin.png" alt />
      </div>
      <div class="game-wrapper">
        <el-row :gutter="20" class="main-box">
          <el-col :span="6" v-for="(item, index) in gameList" :key="index">
            <div class="main-item">
              <a href="javascript:;" class="link-box">
                <img
                  :src="`${item.PicList[0]}?x-oss-process=image/resize,h_100`"
                  class="game-img"
                  alt
                />
                <div class="item-wrapper">
                  <div class="item-box">
                    <h4 v-if="item.Type == 3">
                      {{ beautySub(item.Name, 4) }}
                      <span class="cloud-archiving">支持存档</span>
                    </h4>
                    <h4 v-else>{{ item.Name }}</h4>
                    <div class="text-hidden">
                      <div class="tag-box">
                        <el-tag
                          v-for="(i, index) in item.Labels.split(',')"
                          :key="index"
                          >{{ i }}</el-tag
                        >
                      </div>
                    </div>
                    <a
                      href="javascript:;"
                      :class="
                        item.IsSubscribe == 0 ? 'btn-experience' : 'appointment'
                      "
                      @click="appointment(item)"
                    ></a>
                  </div>
                </div>
              </a>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div v-if="nodata" class="noData">
      <a href="javascript:;" @click="goBack">暂无数据，点我返回</a>
    </div>

    <!-- 启动其他游戏 -->
    <el-dialog
      title="温馨提示："
      :visible.sync="dialogVisible"
      width="400px"
      center
      :close-on-click-modal="false"
    >
      <p class="text-content">{{ str }}</p>
      <p class="text-content">游戏上线后, 我们将通过短信通知您</p>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GetGameSubscribe, GameSubscribe } from "@/api";

// 节流函数
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export default {
  name: "FreeToPlay",
  computed: {
    ...mapGetters([
      "isLogin",
      "netBarId",
      "netBarName",
      "netBarVIP",
      "userInfo",
      "getIsAuth"
    ]),
  },
  data() {
    return {
      isYY: true,
      gameList: [],
      nodata: false,
      dialogVisible: false,
      str: "",
    };
  },
  mounted() {
    // 获取游戏列表
    this._GetGameSubscribe();
  },
  methods: {
    async appointment(obj) {
      if (this.isLogin) {
        let phone = sessionStorage.getItem("Phone");
        if (phone) {
          if (this.getIsAuth && !this.userInfo.IDCard) {
            eventBus.$emit("showAuth");
            return false;
          }

          if (obj.IsSubscribe === 0) {
            let params = {
              consumerId: this.userInfo.ConsumerId,
              gameId: obj.GameID,
              gameName: obj.Name,
              phone: this.userInfo.Phone,
              netbarId: this.netBarId,
              netbarName: this.netBarName,
            };
            let res = await GameSubscribe(params);
            if (res.StatusCode == 200) {
              this.dialogVisible = true;
              this.str = obj.Name + "预约成功!";
              // 获取游戏列表
              this._GetGameSubscribe();
            }
          } else {
            this.$message({
              message: "已预约",
              type: "success",
            });
          }
        } else {
          eventBus.$emit("showLoginPhone");
        }
      } else {
        eventBus.$emit("getQrCode");
      }
    },
    goBack() {
      this.$router.back();
    },

    // 获取游戏列表
    async _GetGameSubscribe() {
      let params = {
        consumerId: (this.userInfo && this.userInfo.ConsumerId) || 0,
      };
      let res = await GetGameSubscribe(params);
      if (res.StatusCode == 200) {
        if (res.Items && res.Items.length) {
          this.gameList = res.Items;
        } else {
          this.nodata = true;
        }
      }
    },
    // 字符串截取
    beautySub(str, len) {
      var reg = /[\u4e00-\u9fa5]/g, //专业匹配中文
        slice = str.substring(0, len),
        chineseCharNum = ~~(slice.match(reg) && slice.match(reg).length),
        realen = slice.length * 2 - chineseCharNum;
      return str.substr(0, realen) + (realen < str.length ? "..." : "");
    },
  },
};
</script>

<style lang="scss" scoped>
.free-to-play-wrapper {
  overflow: hidden;
  .game-list-box {
    padding: 20px;
    width: 1040px;
    height: 676px;
    .title-box {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .game-wrapper {
      height: 606px;
      overflow-x: hidden;
      overflow-y: auto;
      //   overflow: auto;
      .main-box {
        .main-item {
          // width: 240px;
          height: 232px;
          margin-top: 20px;
          // border: 1px solid #cacaca;
          box-sizing: border-box;
          border-radius: 6px;
          overflow: hidden;
          position: relative;
          @include item_bg_col();
          .icon-img {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 101;
          }
          a {
            // width: 244px;
            height: 126px;
            display: block;

            .game-img {
              width: 100%;
              height: 100%;
            }
            .item-wrapper {
              .item-box {
                display: flex;
                flex-direction: column;
                padding: 5px 10px;
                h4 {
                  text-align: center;
                  font-size: 18px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  line-height: 24px;
                  @include font_col3();
                  .cloud-archiving {
                    padding: 5px;
                    margin-left: 10px;
                    background: $linear-col;
                    border-radius: 4px;
                    color: $white-col;
                    font-size: 12px;
                  }
                }
                .tag-box {
                  overflow: hidden;
                  margin: 5px 0;
                  height: 18px;
                  text-align: center;
                  .el-tag {
                    margin-right: 5px;
                    background: none !important;
                    height: 18px;
                    line-height: 18px;
                    border-radius: 4px;
                    @include font_col6();
                  }
                }
                .btn-experience {
                  width: 100%;
                  height: 34px;
                  line-height: 34px;
                  text-align: center;
                  color: $white-col;
                  margin: 2px auto;
                  background: url("./../assets/images/games/appointment_btn1.png")
                    no-repeat;
                  font-size: 16px;
                  border-radius: 4px;
                }
                .appointment {
                  width: 100%;
                  height: 34px;
                  line-height: 34px;
                  text-align: center;
                  color: $white-col;
                  margin: 2px auto;
                  background: url("./../assets/images/games/appointment_btn2.png")
                    no-repeat;
                  font-size: 16px;
                  border-radius: 4px;
                }
              }
            }
          }
        }
        .main-item:nth-child(5n) {
          margin-right: 0;
        }
        .main-item:hover {
          transform: translateY(-5px);
          transition: 0.2s ease;
          box-shadow: -2px 0px 10px 0px rgba(0, 0, 0, 0.2);
          h4 {
            font-weight: bold;
            color: $red-col;
          }

          .btn-experience {
            background: url("./../assets/images/games/appointment_btn.png")
              no-repeat !important;
          }
        }
      }
    }
  }
  .noData {
    display: flex;
    justify-content: center;
    margin: 200px auto;
    a {
      padding: 10px 25px;
      border-radius: 4px;
      font-size: 16px;
      color: $bt-linear-col;
      border: 1px solid $bt-linear-col;
    }
  }

  ::v-deep .el-dialog__body {
    .text-content {
      line-height: 32px;
      font-size: 18px;
      @include font_col3();
    }
  }
}
</style>
